import { render, staticRenderFns } from "./pendingExcursionsComp.vue?vue&type=template&id=0bfdd54c"
import script from "./pendingExcursionsComp.vue?vue&type=script&lang=js"
export * from "./pendingExcursionsComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports